// Categoría de una máquina del Parque de Maquinaria — el backend maneja solo estos 2 códigos
export const CategoriaMaquinariaArray = [
  { id: "JD", display: "JOHN DEERE" },
  { id: "OTRA_MARCA", display: "OTRAS MARCAS" },
];
